export const REDUCER_KEY = 'composers';
export const SET_COMPOSERS = 'SET_COMPOSERS';
export const SET_COMPOSERS_LANG = 'SET_COMPOSERS_LANG';
export const SET_FILTERS_COMPOSERS = 'SET_FILTERS_COMPOSERS';
export const SET_FILTERED_COMPOSERS = 'SET_FILTERED_COMPOSERS';
export const SET_COMMENTS_COMPOSER = 'SET_COMMENTS_COMPOSER';
export const SET_SEARCH_COMPOSER = 'SET_SEARCH_COMPOSER';
export const SET_COMPOSERS_DEFAULTS = 'SET_COMPOSERS_DEFAULTS';
